import { useEffect } from 'react';
import { isRtlLanguage } from '@models/i18n/language.model';
import { useAppStore, selectLanguage } from '@store/app.store';
import { logger } from '@utils/logger.util';

/**
 * Custom hook that manages language direction (dir attribute).
 * Mirrors the Angular LanguageDirectionDirective pattern:
 * - Initializes dir attribute on mount based on current language
 * - Subscribes to language changes and updates dir attribute automatically
 */
export const useLanguageDirection = (): void => {
  const currentLanguage = useAppStore(selectLanguage);

  useEffect(() => {
    const setLanguageDirection = (): void => {
      const direction = isRtlLanguage(currentLanguage) ? 'rtl' : 'ltr';
      document.documentElement.setAttribute('dir', direction);
      document.documentElement.setAttribute('lang', currentLanguage);
      logger.info(`Language direction set to: ${direction} (${currentLanguage})`);
    };

    setLanguageDirection();
  }, [currentLanguage]);
};
